import { render } from "./Pickup.vue?vue&type=template&id=b235087a&ts=true"
import script from "./Pickup.vue?vue&type=script&lang=ts"
export * from "./Pickup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__